import styled from 'styled-components';
import { InfoOutlined } from '@mui/icons-material';
import colors from '../../styles/colors';

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  text-align: center;
  padding: 20px;
  background-color: ${colors.shades.alpha1};
`;

const EmptyViewContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
`;

const InfoIcon = styled(InfoOutlined)`
  margin: 0 10px;
`;

export {
  Container,
  EmptyViewContainer,
  InfoIcon,
};
